export default {
  //全局字典项
  logout: '退出',
  userCode: '用户名',
  group: '集团',
  hotelGroupName: '集团名称',
  hotelName: '酒店名称',
  bizDate: '营业日期',
  code: '用户名',
  name: '姓名',
  sex: '性别',
  roles: '岗位',
  mobile: '手机',
  createDatetime: '创建时间',
  modifyDatetime: '最后登录时间',
  lastLoginDate: '上次登录时间',
  lastIp: '上次登录IP',
  mac: '设备唯一码',
  view: '查看',
  more: '更多',
  add: '新增',
  delete: '删除',
  search: '搜索',
  cancel: '取消',
  exit: '退出',
  determine: '确定',
  selectAll: '全选',
  fliter: '筛选',
  complete: '完成',
  share: '分享',
  refresh: '刷新',
  home: '首页',
  all: '全部',
  other: '其他',
  multi_select: '多选',
  edit: '编辑',
  Copy: '复制',
  CopySuccess: '复制成功',
  myApp: '我的应用',
  operate: '操作',
  reset: '重置',
  empty: '清空',
  maintenance: '维修',
  lock: '锁定',
  reservation: '预定',
  back: '返回',
  remark: '备注',
  success: '成功',
  reason: '原因',
  nothing: '什么都没有',
  senior: '高级',
  search: '查询',
  list: '列表',
  gantt_chart: '甘特图',
  site: '场地',
  modify: '修改',
  shutDown: '关闭',
  hotel: '酒店',
  save: '保存',
  morning: '上午',
  afternoon: '下午',
  evening: '晚上',
  Sunday: '周日',
  Monday: '周一',
  Tuesday: '周二',
  Wednesday: '周三',
  Thursday: '周四',
  Friday: '周五',
  Saturday: '周六',
  thisYear: '今年',
  lastYear: '去年',
  hundredmillion: '亿',
  tenThousand: '万',
  month: '月',
  placeHolder_Empty: '可空',
  sum: '共',
  bi: '笔',
  loading_end_message: '—— 　我是有底线的　 ——',
  sexDesc: '性别',
  sexMale: '男',
  sexFemale: '女',
  status: '状态',
  clear: '清除',
  prderDetail_opera_num: '数量',
  prderDetail_no_data: '无记录',
  prderDetail_opera_fee_type: '费用类型',
  prderDetail_opera_notice: '费用类型只显示OHotel已经配置类型',

  book_no_ratecode: '无此类房价码',

  //全局字典项
  MessageBox_title: '提示',
  MessageBox_confirmButtonText: '确定',
  MessageBox_cancelButtonText: '取消',
  MessageBox_areYouSure: '确定退出？',
  MessageBox_unRepair: '确定解除？',
  MessageBox_keepDebts: '是否要挂账?',
  MessageBox_checkOutAdd: '是否加收房费?',
  MessageBox_checkOutAdd_select: '请选择加收方式',
  MessageBox_checkOutAdd_action0: '加收半天',
  MessageBox_checkOutAdd_action1: '加收全天',
  MessageBox_checkOutAdd_action0_sure: '确定加收半天?',
  MessageBox_checkOutAdd_action1_sure: '确定加收全天?',
  MessageBox_checkIn: '确定办理入住?',
  MessageBox_cancelOrder: '请输入取消原因（可空）',
  MessageBox_delete_meeting: '确定删除:',
  MessageBox_cancel: '确定取消?',
  MessageBox_cancelMeeting: '确定批量修改?',
  MessageBox_use: '确定核销？',
  MessageBox_selectShiftTitle: '选择班别',
  MessageBox_msg_selectShift: '请选择班别',

  msg_delete_success: '删除成功',
  msg_use_success: '使用成功',
  msg_update_success: '更新成功',
  msg_cancel_success: '取消成功',
  msg_modify_success: '修改成功',
  msg_checkin_success: '办理入住成功',
  msg_addReceive_success: '加收成功',
  msg_keepDebts_success: '挂账成功',
  msg_recognize_fail: '语音识别失败：',
  msg_choose_room: '至少选择一个房间',
  msg_choose_checkMethod: '请选择支付方式',
  //book msg
  msg_error_code: '识别失败！请正面对准身份证，当照片清楚时再拍摄。',
  msg_rsvCompanyId4: '请填写中介/旅行社',
  msg_rsvCompanyId3: '请填写协议公司',
  msg_rsvCompanyId2: '请填写会员卡信息',
  msg_rsvMan: '姓名不能为空',
  msg_rmtype: '房型不能为空',
  msg_idCode: '证件类型不能为空',
  msg_range: '入住/离店时间不能为空',
  msg_search: '请输入搜索条件',
  msg_could_not_find: '没有找到',
  msg_choose_reason: '请选择原因',
  msg_no_more_room: '超过本次允许的房间数',
  msg_submitGear: '请先点击排房或入住按钮',
  msg_reserveBook: '请先选择场地时间',
  msg_salesman: '销售人不能为空',
  msg_phone: '联系方式不能为空',
  msg_theme: '主题不能为空',
  msg_category: '宴会类型不能为空',
  msg_linkman: '联系人不能为空',
  msg_cateringPlaceString: '场地列表不能为空',
  msg_beginDateString: '场地开始时间不能为空',
  msg_endDateString: '场地结束时间不能为空',
  msg_meetingBook_sta: '状态不能为空',
  msg_meetingBook_update: '修改会议室成功',
  msg_meetingBook_Success: '预定会议室成功',
  msg_cancelMeeting: '取消会议室成功',
  msg_handleConfirmEnd: '会议结束日期要比开始日期晚。',
  msg_save_fail: '保存失败',

  msg_nav: '本功能需要PMS版本:',
  msg_getDetail: '当前优惠券不可核销',
  msg_getbarcode: '非可核销优惠券类型',
  Toast_nomorethan5: '预警事件不能超过5个',
  Toast_nomorethan11: '您最多可以增加11个',
  Toast_selectcondition: '请选择不同的指标!',
  Toast_pickDate: '起止天数相差不能超过5天',
  Toast_pickDate1: '结束天数必须大于开始天数',
  Toast_addNewTime: '预警时间最多三个',
  Toast_checkCondition: '请完善当前判断条件',
  Toast_checkCondition1: '请完善当前判断条件',
  Toast_checkCondition2: '数据上界必需大于数据下界',
  Toast_del_last: '无法删除最后一个',
  Toast_save_rule: '请输入事件名称',
  Toast_save_rule1: '请输入具体提前天数',
  Toast_save_rule_time: '请输入预警时间',
  Toast_noticeContent: '请输入提醒内容',
  Toast_save_success: '保存成功！',
  //导航 首页
  index_refresh: '下拉刷新',
  index_homeData_title: '预计本日总营收',
  index_homeData_analy: '可售',
  index_homeData_analy_unit: '间',
  index_homeData_analysis: '过夜出租率',
  index_homeData_analysis_avg: '过夜均价',
  index_homeData_angle_allNum: '总房数',
  index_homeData_angle_allNum_unit: '间',
  index_homeData_angle_sorted: '已售房',
  index_homeData_angle_sorted_rate: '已售率',
  index_homeData_angle_sort: '可售房',
  index_homeData_angle_takeUp: '占用房',
  index_homeData_angle_maintenance: '维修房',
  index_homeData_angle_personalUse: '自用房',
  index_homeData_angle_free: '免费房',
  index_homeData_angle_lock: '锁定房',

  index_homeData_angle_lock_oo: '大修',
  index_homeData_angle_lock_os: '小修',

  index_homeData_notarrRoom: '本日将到',
  index_homeData_isarrRoom: '本日已到',
  index_homeData_notdepRoom: '本日未离',
  index_homeData_isdepRoom: '本日已离',


  index_homeData_define: '指标定义',
  index_new_version: '版本更新说明',
  footNav_home: '首页',
  footNav_info: '消息',
  footNav_discover: '发现',
  footNav_center: '我的',
  //moreFunction
  moreFunction_tip: '按住拖动调整排序',
  //login
  login_hotelCode: '酒店代码',
  login_username: '用户名',
  login_password: '请输入密码',
  login_login: '登录',
  login_pleseRemember: '记住账号密码',
  login_saved_Password: '保存的密码',
  login_hotelCode_Not_Empty: '请填写酒店代码',
  login_username_Not_Empty: '请填写用户名',
  login_password_Not_Empty: '请填写密码',
  login_only_code: '唯一码',


  //serarch
  search_title: '切换酒店',
  search_placeholder: '酒店代码/酒店部分名称',
  search_often: '常用',
  search_city: '城市',
  search_brand: '品牌',
  search_area: '区域',
  search_hotel: '酒店',
  search_all: '所有',
  // fangT
  fangT_title: '房态',
  fangT_placeholder: '房号/姓名',
  fangT_category_name: '大小房',
  fangT_rmno: '房号',
  fangT_rmno_placeholder: '请输入房号',
  fangT_staNew: '修改房态',
  fangT_rmnos: '房间号码',
  fangT_rmnos_placeholder: '输入房号（必填）',
  fangT_sta: '操作类型',
  fangT_beginDate: '开始日期',
  fangT_endDate: '结束日期',
  fangT_reasonCode: '选择原因',
  fangT_remark_placeholder: '输入备注（可空）',
  fangT_mutlSelectTitle: '已选择 0 项',
  fangT_mutlSelectTitleText: '已选择',
  fangT_mutlSelectTitUnit: '项',
  fangT_view: '查看',
  fangT_RoomStaI: '检查',
  fangT_RoomStaR: '干净',
  fangT_RoomStaD: '脏房',
  fangT_RoomStaPU: '小修',
  fangT_reserveBook: '预订',
  fangT_walkBook: '入住',
  fangT_RoomStaOOO: '维修',
  fangT_RoomStaOOS: '锁定',
  fangT_unRepair: '解除',
  fangT_building: '楼栋',
  fangT_floor: '楼层',
  fangT_rmtype: '房型',
  fangT_feature: '特征',
  fangT_villadataV: '可用',
  fangT_villadataB: '大房',
  fangT_villadataS: '小房',

  // opera新增的
  fangT_sure_prev: '确定把 ',
  fangT_sure_clean: ' 的房态修改为干净吗',
  fangT_sure_dirty: ' 的房态修改为脏房吗',
  fangT_sure_inspected: ' 的房态修改为检查吗',
  fangT_sure_small_build: '查询小房态时请先选择楼栋',
  fangT_sure_small_build_most_before: '最多查询 ',
  fangT_sure_small_build_most_after: ' 栋楼',
  fangT_sure_same_status: '不能同时选择状态不一样房间',
  fangT_sure_check_small: '查看小房态',
  fangT_sure_check_orderDetail: '查看订单',

  //fangQ
  fangQ_title: '房情',
  fangQ_title1: '经营情况',
  fangQ_title2: '客房情况',
  fangQ_date: '日期',
  fangQ_takeup: '占用',
  fangQ_available: '可用',
  fangQ_maintenance: '维修',
  fangQ_average_price: '均价',
  fangQ_rents: '出租率',
  fangQ_action: '操作',
  fangQ_detail: '明细 >',
  fangQ_orderDetail_free: '空闲',
  fangQ_select_modal: '客房范围',
  fangQ_select_title: '客房范围选择',
  fangQ_left_top_title: '楼号',
  fangQ_left_bottom_title: '大房类',
  fangQ_notice_text: '已选范围',

  //fangXQ
  fangXQ_title: '房详情',
  fangXQ_rmtype: '房型',
  fangXQ_total_num: '总房数',
  fangXQ_available: '可售',
  fangXQ_takeup: '占用',
  fangXQ_maintenance: '维修',
  fangXQ_toogle_type: '按大类',
  fangXQ_toogle_detail: '按明细',

  //book
  book_title: '房态详情',
  book_active1: '散客',
  book_active2: '会员',
  book_active3: '协议公司',
  book_active4: '订房中心',
  book_active5: '旅行社',
  book_name5: '旅行社',
  book_name4: '订房中心',
  book_name3: '协议公司',
  book_name2: '会员卡',
  book_rsvMan: '姓名',
  book_rsvMan_placeholder: '请填写预订人姓名（必填）',
  book_mobile: '手机',
  book_mobile_placeholder: '请填写11位手机号码（可空）',
  book_idCode: '证件类型',

  book_idNo: '证件号码',
  book_idNo_placeholder: '请填写证件号码(可空)',
  book_idNo_placeholder_required: '请填写证件号码(必填)',
  book_range: '入住/离店',
  book_rmnum: '房间数',
  book_rmno: '房间号',
  book_rmtype: '房型',
  book_ratecode: '房价码',
  book_firstDayMoney: '首日房价',
  book_pkage: '包价',
  book_more_parmas: '更多参数',
  book_packup_parmas: '收起参数',
  book_rateSecret: '房价保密',
  book_rsvType: '预订类型',
  book_market: '市场',
  book_src: '来源',
  book_channel: '渠道',
  book_cms_code: '佣金码',
  book_payCode: '付款码',
  book_salesman: '销售员',
  book_salesman_placeholder: '请选择销售员',
  book_coMsg: '结账提醒',
  book_otaRsvNo: 'OTA预订号',
  book_creditMan: '手工编号',
  book_specials: '特殊要求',
  book_amenities: '客房布置',
  book_origin_price: '原价',
  book_reason: '优惠理由',
  book_sync: '同步所有',
  book_select_type: '请选择房型',
  book_reset_price_notice: '预定信息有变动，请重新设置自定义价格',
  book_define_title: '自定义房价',


  book_remark: '备注',
  book_amount: '总价',
  book_count: '费用明细',
  book_rmnum: '房数',
  book_total: '费用合计',
  book_reserveBook: '预定',
  book_walkBook: '入住',
  book_disRmType_des: '（房量不足）',
  book_disRmType_left: ' -- 剩',
  book_disRmType_unit: '间',
  book_addRmType_btn: '新增房型',
  book_removeRmType_btn: '删除房型',
  //fangTXQ
  fangTXQ_title: '登记单详情',
  fangTXQ_rsvNo: '预订单号',
  fangTXQ_sta: '状态',
  fangTXQ_baseInfo: '基础信息',
  fangTXQ_reserveBook: '预定',
  fangTXQ_name: '姓名',
  fangTXQ_mobile: '手机',
  fangTXQ_name2: '姓名2',
  fangTXQ_firstName: '姓/名',
  fangTXQ_rmno: '房号',
  fangTXQ_rmtype: '房类',
  fangTXQ_arr: '抵店',
  fangTXQ_dep: '离店',
  fangTXQ_memberNo: '卡号',
  fangTXQ_realRate: '房价',
  fangTXQ_idCode: '证件类型',
  fangTXQ_idNo: '证件号码',
  fangTXQ_idNo_placeholder: '请输入证件号码',
  fangTXQ_companyName: '协议公司',
  fangTXQ_agentName: '旅行社',
  fangTXQ_sourceName: '订房中心',
  fangTXQ_pmsTimesIn: '门店入住次数',
  fangTXQ_timesIn: '集团入住次数',
  fangTXQ_ratecode: '房价码',
  fangTXQ_market_sales: '市场销售',
  fangTXQ_salesman: '销售',
  fangTXQ_rsvTypeName: '预订类型',
  fangTXQ_market: '房价码',
  fangTXQ_src: '来源',
  fangTXQ_cmscode: '佣金码',
  fangTXQ_channel: '渠道',
  fangTXQ_payCode: '付款码',
  fangTXQ_crsNo: '中央预订号',
  fangTXQ_packagesDis: '包价',
  fangTXQ_other: '其他',
  fangTXQ_remark: '备注',
  fangTXQ_createUser: '创建人',
  fangTXQ_createDatetime: '创建时间',
  fangTXQ_modifyUser: '修改人',
  fangTXQ_modifyDatetime: '修改时间',
  fangTXQ_sepcials: '特别说明',

  fangTXQ_live_with: '同住',
  fangTXQ_none: '无',
  fangTXQ_al_room: '联房',

  fangTXQ_bill: '账单',
  fangTXQ_masterBase: '余额',
  fangTXQ_credit: '信用',
  fangTXQ_othBalance: '余额合计',
  fangTXQ_othCredit: '信用合计',
  fangTXQ_coMsg: '结账提醒',
  fangTXQ_project: '项目',
  fangTXQ_time: '时间',
  fangTXQ_operator: '操作员',
  fangTXQ_amount: '金额',
  fangTXQ_cancelOrder: '取消订单',
  fangTXQ_checkIn: '办理入住',
  fangTXQ_addReceive1: '加收全天',
  fangTXQ_addReceive0: '加收半天',
  fangTXQ_keepDebts: '挂账',
  fangTXQ_checkOut: '退房',

  fangTXQ_needMoney: '应收金额',
  fangTXQ_needMoney2: '实收金额',
  fangTXQ_checkMethod: '结账类型',
  fangTXQ_payName: '付款人',
  fangTXQ_invoice_title: '发票抬头',

  fangTXQ_date: '日期',
  fangTXQ_rate: '房价',
  fangTXQ_rmnum: '房间数',
  fangTXQ_total: '合计',

  fangTXQ_addReceiveMsg0: '是否加收半天?',
  fangTXQ_addReceiveMsg1: '是否加收全天?',

  fangTXQ_orderDisD: '钟点',
  fangTXQ_orderDisG: '团队',
  fangTXQ_amenities: '客房布置',
  fangTXQ_specials: '特殊要求',
  fangTXQ_creditMan: '手工编号',
  fangTXQ_otaRsvNo: 'OTA订单号',

  fangTXQ_changeRoomTitle: '选择换房房间',
  fangTXQ_changeRoomNoRoom: '没有查询到可以更换的房间',
  fangTXQ_changeRoomSuccess: '换房成功',

  fangTXQ_scanPay_title:'扫码支付',
  fangTXQ_bookName:'入住人',
  fangTXQ_bookTime:'入住时间',
  fangTXQ_savePictrue:'保存图片',
  fangTXQ_forwardWechat:'转发给微信好友',
  fangTXQ_generateQrCode:'生成二维码',
  fangTXQ_transactionAmount:'交易金额',
  fangTXQ_pleaseTransactionAmount:'请输入交易金额',
  fangTXQ_cannotTransactionAmount:'交易金额不能为空',

  // 扫码支付
  scanPay_title: '扫码支付',
  scanPay_save: '入账',
  scanPay_money_placeholder: '请填写本次入账费用（必填）',
  scanPay_rmno: '房间号',
  scanPay_name: '姓名',
  scanPay_taCode: '代码',
  scanPay_money: '费用',
  scanPay_taNo: '单号',
  scanPay_taRemark: '备注',
  scanPay_history: '支付记录',
  scanPay_operator: '操作员',
  scanPay_date: '日期',
  scanPay_refund: '退款',
  scanPay_refund_check: '退款核对',
  scanPay_slide_notice: '左滑可进行退款核对和退款',
  scanPay_action_reAccount: '入账核对',
  scanPay_action_reAccountSuccess: '入账核对成功',
  scanPay_success: '退款成功',

  scanPay_refund_amount: '可退金额',
  scanPay_no_refund_amount: '可退金额为 0',
  scanPay_refund_amount_placeholder: '请输入退款金额',
  scanPay_refund_error_money: '请输入正确的退款金额',
  scanPay_refund_error_money2: '退款金额不能大于可退金额',

  // 添加同住人
  addLiveWith_title: '新增同住人',
  addLiveWith_no_name: '请填写姓名',
  addLiveWith_no_sex: '请选择性别',
  addLiveWith_no_vip: '请选择VIP',
  addLiveWith_nation: '国籍',
  addLiveWith_language: '语言',
  addLiveWith_checkIn: '立即入住',
  addLiveWith_copyPackage: '复制包价',
  addLiveWith_same_rsvn_no: '相同预定号',
  addLiveWith_name: '姓名',
  addLiveWith_name_place: '请填写同住人姓名（必填）',

  delayIn_Title: '续住',
  delayIn_newEndDate: '离店日期（新）',
  delayIn_EndDate: '离店日期',
  delayIn_days: '续住天数',
  delayIn_confirm: '确定续住到：',
  delayIn_success: '续住成功',

  //入账
  incomeAccount_tilte: '入账',
  incomeAccount_roomNo: '房间号',
  incomeAccount_name: '姓名',
  incomeAccount_code: '代码',
  incomeAccount_fee: '费用',
  incomeAccount_fee_placehold: '请填写本次入账费用（必填）',
  incomeAccount_orderNo: '单号',
  incomeAccount_remark: '备注',
  incomeAccount_save: '入账',
  incomeAccount_empty_feeCode: '请选择费用代码',
  incomeAccount_empty_money: '请填写费用金额',
  incomeAccount_error_money: '请填写正确金额',
  incomeAccount_confirm_money: '确定入账金额：',
  incomeAccount_success: '入账成功',

  incomeAccount_select_subAccount_pl: '选择分账户',
  incomeAccount_select_subAccount_title: '分账户',
  incomeAccount_msg_select_subAccount: '请选择分账户',
  incomeAccount_msg_ar_company: '请选择签单公司',
  incomeAccount_msg_ar_account: '请选择签单人',
  incomeAccount_msg_ar_select_company: 'AR公司',
  incomeAccount_msg_ar_select_amount: '余额',
  incomeAccount_msg_ar_arno: '手工编号',
  incomeAccount_msg_ar_coding: '编码',
  incomeAccount_msg_ar_avaliable_date: '有效期',
  incomeAccount_msg_ar_avaliable_date_center: '至',

  incomeAccount_msg_ar_no_date: '该公司不在有效期范围内',
  incomeAccount_msg_ar_no_status: '该公司目前不可用',

  //更新订单备注
  updateRemark_title: '追加备注',
  updateRemark_confirm: '确定追加备注信息?',
  updateRemark_notEmpty: '备注不能为空',

  //orderList
  orderList_title: '订单列表',
  orderList_searchText_placeholder: '姓名/手机/登记单号',
  orderList_notArr: '本日将到',
  orderList_hasArr: '本日已到',
  orderList_allHasArr: '全部已到',
  orderList_notDep: '未离',
  orderList_hasDep: '已离',
  orderList_allReserve: '有效预订',
  orderList_rsvNo: '订单号',
  orderList_rsvClassF: '散客',
  orderList_rsvClassD: '钟点',
  orderList_rsvClassG: '团队',
  orderList_username: '姓名',
  orderList_mobile: '手机',
  orderList_arr: '到离',
  orderList_rmtype: '房类',
  orderList_realRate: ' 房价',
  orderList_member_no: '卡号',
  orderList_member_crpName: '公司',
  orderList_category_name: '销售员',
  orderList_showCategory: '[清空]',
  orderList_arr_S: '到离',
  orderList_tip: '仅作用于类别 “有效预订”',
  orderList_dep_S: '离店起止日期',

  orderList_total: '共',
  orderList_rmnum: '房数',
  orderList_ordernum: '单',
  orderList_peoplenum: '人',

  //orderDetail
  orderDetail_title: '订单详情',
  orderDetail_crsNo: '订单号',
  orderDetail_sta: '状态',
  orderDetail_checkIn_info: '入住信息',
  orderDetail_rsvArrDate: '抵店',
  orderDetail_rsvDepDate: '离店',
  orderDetail_rmtypes: '房型',
  orderDetail_rmtypes_unit: '间',
  orderDetail_paiF: '排房',
  orderDetail_arr: '抵店',
  orderDetail_dep: '离店',
  orderDetail_pick_room: '选房',

  orderDetail_realRate: '房价',
  orderDetail_name: '姓名',
  orderDetail_idNo: '证件号',
  orderDetail_rsvNo: '房间号',
  orderDetail_sex: '性别',
  orderDetail_sex1: '男',
  orderDetail_sex2: '女',
  orderDetail_staI: '已入住',
  orderDetail_staO: '已离店',
  orderDetail_staS: '已挂账',
  orderDetail_staX: '已取消',
  orderDetail_realRate: '房价',
  orderDetail_isSecretRate: '【保密】',
  orderDetail_totalmoney: '总房价',
  orderDetail_bookInfo: '总房价',
  orderDetail_bookName: '预订人',
  orderDetail_memberNo: '卡号',
  orderDetail_mobile: '手机',
  orderDetail_mobile_placeholder: '手机（可空）',
  orderDetail_payment_info: '预收款信息',
  orderDetail_pay: '预收款',
  orderDetail_credit: '预授权',
  orderDetail_charge: '余额',

  orderDetail_checkin: '排房/入住',
  orderDetail_guest_info: '住客信息',
  orderDetail_guest_name: '姓名',
  orderDetail_guest_name_placeholder: '请输入姓名',
  orderDetail_search_room: '搜索本订单房间',
  orderDetail_room: '房间',
  orderDetail_has_chosen: '已选择',
  //repair
  repair_title: '房间详情',
  repair_staS: '锁定房',
  repair_staO: '维修房',
  repair_begin: '开始',
  repair_end: '结束',
  //meetingOrder
  meetingOrder_title: '会议订单',
  meetingOrder_seachContent_placeholder: '主题/预定名称/联系人/电话',
  meetingOrder_all: '全部',
  meetingOrder_theme: '主题',
  meetingOrder_order: '预定',
  meetingOrder_fast: '快捷',
  meetingOrder_dateBegin: '开始时间',
  meetingOrder_dateEnd: '结束时间',
  meetingOrder_linkMan: '姓名',
  meetingOrder_phone: '联系电话',
  meetingOrder_sort: '排序方式',

  meetingOrder_in_the_day: '当天',
  meetingOrder_today: '今天',
  meetingOrder_tomorrow: '明天',
  meetingOrder_tomorrow2: '后天',
  meetingOrder_orderdata1: '按时间',
  meetingOrder_orderdata2: '按场地',

  meetingOrder_staR: '不确定',
  meetingOrder_staI: '确定',
  meetingOrder_staX: '取消',
  meetingOrder_staD: '删除',
  meetingOrder_staG: '担保',
  meetingOrder_staS: '自用',
  meetingOrder_staO: '维修',
  //meetingBook
  meetingBook_title1: '预定会议室',
  meetingBook_title: '修改会议室',
  meetingBook_theme_placeholder: '请填写会议主题',
  meetingBook_categoryCode: '宴会类型',
  meetingBook_linkman: '联系人',
  meetingBook_linkman_placeholder: '请填写联系人',
  meetingBook_phone: '联系方式',
  meetingBook_phone_placeholder: '请填写联系方式',
  meetingBook_board: '指示牌',
  meetingBook_board_placeholder: '请填写指示牌（可空）',

  meetingBook_rsvName: '预订名称',
  meetingBook_booking: '预订中',
  meetingBook_rsvName_placeholder: '请填写预订名称（可空）',
  meetingBook_peopleNumber: '人数',
  meetingBook_peopleNumber_placeholder: '请填写人数（可空）',
  meetingBook_tables: '桌数',
  meetingBook_tables_placeholder: '请填写桌数（可空）',
  meetingBook_rate: '费用',
  meetingBook_rate_placeholder: '请填写费用（可空）',
  meetingBook_resRate: '资源费用',
  meetingBook_resRate_placeholder: '请填写资源费用（可空）',
  meetingBook_comRate: '综合费用',
  meetingBook_comRate_placeholder: '请填写综合费用（可空）',

  meetingBook_agreement_unit: '协议单位',
  meetingBook_remark: '备注',
  meetingBook_not_support: '酒店不支持会议',

  meetingBook_meeting_room: '会议室',
  meetingBook_meeting_room_unit: '场',
  meetingBook_events_list: '场次列表',
  meetingBook_tip: '点击日期修改可修改时间，仅限制当前场次范围',
  //meetingCancel
  meetingCancel_title: '会议批量取消',
  //meetingEdit
  meetingEdit_title: '会议批量修改',
  meetingEdit_theme: '主题',
  meetingEdit_theme_placeholder: '如需修改填写新的主题',
  meetingEdit_staCode: '状态',
  meetingEdit_staCode_placeholder: '如需修改选择新状态',
  meetingEdit_board: '指示牌',
  meetingEdit_board_placeholder: '如需修改填写新的指示牌',

  meetingEdit_categoryCode: '宴会类型',
  meetingEdit_categoryCode_placeholder: '如需修改选择新宴会类型',
  meetingEdit_rsvName: '预定名称',
  meetingEdit_rsvName_placeholder: '如需修改填写新的预定名称',

  meetingEdit_salesman: '销售员',
  meetingEdit_salesman_placeholder: '如需修改选择新销售员',

  meetingEdit_linkman: '联系人',
  meetingEdit_linkman_placeholder: '如需修改填写新的联系人',

  meetingEdit_phone: '联系电话',
  meetingEdit_phone_placeholder: '如需修改填写新的联系电话',
  meetingEdit_must_select: '必需选择一条',
  //会议详情
  meetingDetail_title: '会议订单详情',
  meetingDetail_orderNo: '预订单号',
  meetingDetail_totalFee: '总费用',
  meetingDetail_placeInfo: '场馆信息',
  meetingDetail_catNo: '宴会编号',
  meetingDetail_categoryCode: '宴会类型',
  meetingDetail_theme: '主题',
  meetingDetail_sta: '状态',
  meetingDetail_placeDes: '场地',
  meetingDetail_board: '指示牌',
  meetingDetail_remark: '备注',
  meetingDetail_orderInfo: '预订信息',
  meetingDetail_rsvName: '预订名称',
  meetingDetail_tables: '桌数',
  meetingDetail_dateBegin: '开始时间',
  meetingDetail_dateEnd: '结束时间',
  meetingDetail_peopleNumber: '人数',
  meetingDetail_linkMan: '联系人',
  meetingDetail_tel: '电话',
  meetingDetail_salesman: '销售',
  meetingDetail_company: '协议单位',
  meetingDetail_rate: '费用',
  meetingDetail_comRate: '综合费用',
  meetingDetail_other: '其他',
  meetingDetail_createDate: '创建时间',
  meetingDetail_modifyDate: '修改时间',
  meetingDetail_batModify: '批量修改',
  meetingDetail_batCancel: '批量取消',

  //cityState
  cityState_title: '同城房态',
  cityState_search_placeholder: '酒店名/代码',

  //index_homeData_analysis: "",
  //导航 消息
  //导航 我的
  info_title: '消息',
  info_send_message: '发送消息',
  info_readStatusNull: '全部',
  info_readStatus0: '未读',
  info_readStatus1: '已读',
  //infoDetail
  infoDetail_title: '消息',
  infoDetail_eventName: '事件名称',
  infoDetail_noticeContent: '提醒内容',
  infoDetail_hotelNames: '酒店名称',
  infoDetail_dateCondition: '日期条件',
  infoDetail_checkTime: '检查时段',
  infoDetail_quota: '检查指标',
  infoDetail_quotaCondition: '指标条件',
  infoDetail_values: '实际数据',
  infoDetail_noticeDatetime: '运算时间',
  infoDetail_close: '知道了',

  // pushMessage 消息推送
  pushMessage_page_title: '消息',
  pushMessage_title: '标题',
  pushMessage_content: '内容',
  pushMessage_receiver: '消息接收人',
  pushMessage_receiver_placeholder: '请选择消息接收人(最多可选20个人)',
  pushMessage_require_title: '请输入消息标题',
  pushMessage_title_too_long: '消息标题太长，请不要超过40个字',
  pushMessage_require_content: '请输入消息内容',
  pushMessage_require_receiver: '请选择消息接收人',
  pushMessage_require_receiver_overmax: '最多可以选择20位接收人',
  pushMessage_save: '发送',
  MessageBox_pushMessage_save: '确定发送',
  pushMessage_success: '发送成功',

  // pushMessageDetail
  pushMessageDetail_page_title: '消息详情',
  pushMessageDetail_title: '标题',
  pushMessageDetail_content: '内容',
  pushMessageDetail_sendTime: '发送时间',
  pushMessageDetail_receive_title: '消息接收情况',
  pushMessageDetail_status_readed: '已读',
  pushMessageDetail_status_no_redead: '未读',


  //cateringOrder
  cateringOrder_title: '餐饮订单',
  cateringOrder_search_placeholder: '预订名称/姓名/手机/订单号',
  cateringOrder_accnt: '预订单号',
  cateringOrder_linkMan: '姓名',
  cateringOrder_resName: '预订名称',
  cateringOrder_tablenoDes: '主桌号',
  cateringOrder_phone: '联系电话',
  cateringOrder_gsts: '人数',
  cateringOrder_bizDate: '就餐时间',
  cateringOrder_shift: '班别',
  cateringOrder_pccode: '营业点',
  cateringOrder_beginDate: '开始日期',
  cateringOrder_endDate: '结束日期',

  cateringOrder_shift_1: '早班',
  cateringOrder_shift_2: '中班',
  cateringOrder_shift_3: '晚班',
  cateringOrder_shift_4: '夜班',
  cateringOrder_shift_R: '预定',
  cateringOrder_shift_N: '未到',
  cateringOrder_shift_C: '确认',
  cateringOrder_shift_I: '登记',
  cateringOrder_shift_X: '取消',

  //cateringDetail
  cateringDetail_title: '餐饮详情',
  cateringDetail_venue_info: '场馆信息',
  cateringDetail_hotelCode: '预订酒店',
  cateringDetail_shiftDes: '预订时间',
  cateringDetail_pccodeDes: '营业点',
  cateringDetail_type1Des: '餐单类别',
  cateringDetail_tablenoDes: '主桌号',
  cateringDetail_exttableno: '扩展桌号',
  cateringDetail_res_info: '预订信息',
  cateringDetail_amount: '用餐标准',
  cateringDetail_standardType: '标准类型',
  cateringDetail_numb: '桌数',
  cateringDetail_beginTime: '开始时间',
  cateringDetail_modeDes: '优惠模式',
  cateringDetail_endTime: '结束时间',
  cateringDetail_pay: '预付金额',
  cateringDetail_payTypeDes: '付款方式',
  cateringDetail_info: '备注',
  cateringDetail_con_info: '联系信息',
  cateringDetail_linkMan: '联系人',
  cateringDetail_phone: '电话',
  cateringDetail_haccntName: '宾客信息',
  cateringDetail_love: '宾客喜好',
  cateringDetail_cusinfo: '协议单位',
  cateringDetail_cardNo: '会员卡号',
  cateringDetail_cardName: '会员名称',
  cateringDetail_saleInfo: '销售',
  cateringDetail_marketDes: '市场',
  cateringDetail_sourceDes: '来源',
  cateringDetail_cancel_confirm: '确定取消订单吗？',
  cateringDetail_cancel_success: '订单取消成功',

  // 餐饮预订
  cateringCreate_title: '餐饮预订',
  cateringCreate_workstation: '营业点',
  cateringCreate_peopleNumber: '人数',
  cateringCreate_peopleNumber_placeholder: '请填写人数',
  cateringCreate_bookDate: '预订日期',
  cateringCreate_bookTime: '预订时间',
  cateringCreate_bookTime_placeholder: '请选择预订时间',
  cateringCreate_linkman: '联系人',
  cateringCreate_linkman_placeholder: '请填写联系人',
  cateringCreate_phone: '联系方式',
  cateringCreate_phone_placeholder: '请填写联系方式',
  cateringCreate_tableType: '桌位类型',
  cateringCreate_tableNo: '桌号',
  cateringCreate_notice_workstation: '请选择营业点',
  cateringCreate_notice_bookDate: '请选择预定日期',
  cateringCreate_notice_success: '预定成功',

  //shirtReport
  shirtReport_title: '交班报表',
  shirtReport_info: '缴款信息',
  shirtReport_bill_info: '入账信息',
  shirtReport_all_class: '全部班级',
  shirtReport_all_user: '全部用户',
  //eventinfo
  eventInfo_title: '事件编辑',
  eventInfo_descript: '事件名称',
  eventInfo_descript_placeholder: '请输入事件名称',
  eventInfo_receiver: '预警接收人',
  eventInfo_receiver_placeholder: '请选择预警接收人',


  addNewEvent_date_con: '日期条件',
  addNewEvent_date_con_placeholder: '请输入事件名称',
  eventInfo_today: '当天',
  eventInfo_days_advance: '提前天数',
  eventInfo_days_start: '天数开始',
  eventInfo_days_stop: '天数结束',
  eventInfo_timeListAnimation: '预警系统判断 * 到 * 天之后的指标数据（按天）',
  eventInfo_pickerValue_label: '触发时间',
  eventInfo_eventTimeInput_label: '请选择时间',
  eventInfo_addEventTime: '+ 新增时间条件',
  eventInfo_conditions: ' 判断条件',
  eventInfo_quotaDescript: '指标',
  eventInfo_operation: '条件',
  eventInfo_valLeft: '数据下界',
  eventInfo_valRight: '条件',
  eventInfo_valRight_placeholder: '数据上界（必于大于下界）',
  eventInfo_val: '数值',
  eventInfo_val_placeholder: '条件数据',
  eventInfo_addNewConditions: '+ 新增判断条件',
  eventInfo_tip: '提醒内容',
  eventInfo_checklistVal: '是否启用',
  eventInfo_tipContent_placeholder: '请输入提醒内容(必填)',
  //addNewEvent
  addNewEvent_title: '新建事件',

  //member
  member_title: '会员分析',
  member_time_type: '时间类型',
  member_time_type_day: '按天',
  member_time_type_month: '按月',
  member_time_trend: '会员趋势',


  member_mroption: '发展方式',
  member_new_member: '新会员',
  member_pay: '充值',
  member_pay_detail: '[明细]',
  member_charge: '消费',
  member_card_type: '卡类',
  member_ship_card: '会员卡类',
  member_data_class: '数据分类',
  member_dataSort_buyCount: '会员发展数',
  member_dataSort_charge: '充值费用',
  member_dataSort_pay: '消费费用',
  member_growType_0: '全部',
  member_growType_1: '线上',
  member_growType_2: '线下',
  member_all_cardType: '全部卡类',
  member_trend: '全部卡类',

  //memberDetailPay
  memberDetailPay_title: '充值明细',
  memberDetailPay_payment: '支付方式',
  memberDetailPay_amount: '金额',
  memberDetailPay_total: '合计',
  //memberDetailCharge
  memberDetailCharge_title: '消费明细',
  memberDetailPay_category: '类别',
  //memberDetailCharge
  revenueCompare_title: '营收对比',
  revenueCompare_month: '月',

  revenueCompare_sequential: '环比',
  revenueCompare_compared: '同比',
  revenueCompare_rev_ttl: '总收入',
  revenueCompare_rev_rm: '房费收入',
  revenueCompare_rev_fb: '餐费收入',
  revenueCompare_rev_ot: '其他收入',
  revenueCompare_rm_avg: '平均房价',
  revenueCompare_rm_occ: '出租率',

  revenueCompare_rev_rmot: '客房其他',
  revenueCompare_rev_meet: '会议',
  revenueCompare_rev_sport: '康乐',
  revenueCompare_rev_ent: '娱乐',
  revenueCompare_rev_ex: '代收',

  revenueCompare_by_month: '按月',
  revenueCompare_by_day: '按日',
  revenueCompare_choose_date: '选择日期',
  revenueCompare_table_date1: '日期一',
  revenueCompare_table_date2: '日期二',
  revenueCompare_choose_get1: '营收一',
  revenueCompare_choose_get2: '营收二',
  revenueCompare_time_dur1: '时间段一',
  revenueCompare_time_dur2: '时间段二',

  revenueCompare_type_title1: '今年去年',
  revenueCompare_type_title2: '去年前年',
  revenueCompare_type_title3: '前年大前年',
  revenueCompare_type_title4: '大前年大大前年',
  revenueCompare_type_title_RT: '今年前年',
  revenueCompare_type_title_custom: '自定义年份',

  revenueCompare_type_lastyear1: '前年',
  revenueCompare_type_lastyear2: '大前年',
  revenueCompare_type_lastyear3: '大大前年',



  revenueCompare_message1: '时间段二的结束日期不能大于今天',
  revenueCompare_message2: '查询的时间间隔不能大于31天',



  // revenueReportChart // 营收图表
  revenueReportChart_title: '营收大类图表',

  //revenueReport
  revenueReport_title: '营收情况',
  revenueReport_project: '营收情况',
  revenueReport_quantity: '笔数',
  revenueReport_daily: '日营收',
  revenueReport_month: '月累计',
  revenueReport_year: '年累计',
  revenueReport_nothing: '什么都没有，请检查当日夜审情况',
  //cashierReport
  cashierReport_title: '收款情况',
  cashierReport_project: '项目',
  //payReport
  payReport_title: '结账情况',
  payReport_title1: '收款合计',
  payReport_title2: '收入合计',
  //roomPrediectionReport
  roomPrediectionReport_title: '房类预测',
  roomPrediectionReport_title1: '收款合计',
  roomPrediectionReport_saled: '已售',
  //orderFromReport
  orderFromReport_title: '客源情况',
  orderFromReport_switchbtn_title: '市场',
  orderFromReport_switchbtn_title2: '渠道',
  orderFromReport_switchbtn_title3: '来源',
  orderFromReport_choose: '选择指标',
  orderFromReport_rent: '出租数',
  orderFromReport_rm_avg: '平均房价',
  orderFromReport_rm_occ: '出租率',
  orderFromReport_total_charge: '总房费',
  orderFromReport_rev_rm: '房费',
  orderFromReport_chart_series_name: '访问来源',


  RmtypeFloor_title: '房类楼层',
  RmtypeFloor_switchbtn_title: '房类',
  RmtypeFloor_switchbtn_title2: '楼层',
  RmtypeFloor_switchbtn_title3: '楼栋',
  RmtypeFloor_choose: '选择指标',

  opera_index_detail_title: '经营数据',
  //indexDetail
  indexDetail_title: '排行榜',
  indexDetail_sort: '高到低',
  indexDetail_rentRate: '出租率',
  indexDetail_revenue: '总收入',
  indexDetail_roomrevenue: '房费收入',
  indexDetail_foodrevenue: '餐饮收入',
  indexDetail_avgPrice: '平均房价',
  indexDetail_revMem: '会员卡费收入',
  indexDetail_revEnt: '娱乐收入',
  indexDetail_revHrs: '钟点房费收入',
  indexDetail_otherrevenue: '其它收入',
  //indexDesc
  indexDesc_title: '指标说明',
  indexDesc_total_revenue: '预计本日总营收',
  indexDesc_total_revenue_value: '预计房费收入(不含钟点)+',
  indexDesc_total_revenue_value1: '餐饮实际收入+其它实际收入',
  indexDesc_available: '可售',
  indexDesc_available_value: '当日可售过夜房数',
  indexDesc_take_up_room: '占用房',
  indexDesc_take_up_room_value: '当前在住 - 预计离店 + 预计到达',
  indexDesc_take_up_room_value_normal: '当前在住-预计离店+预计到达-自用房-免费房',
  indexDesc_overnight_rate: '过夜出租率',
  indexDesc_overnight_rate_value: '占用房/总房数',
  indexDesc_night_average_value: '预计房费收入(不含钟点)/占用房',
  indexDesc_night_average: '过夜均价',
  indexDesc_REVPAR_value: '过夜出租率 * 过夜均价',
  indexDesc_total_rooms: '总房数',
  indexDesc_total_rooms_value: '物理总房数（不含假房）',
  indexDesc_since_room: '自用房',
  indexDesc_since_room_value: '“市场”为“自用”的登记单',
  indexDesc_since_room_value1: '对应的房间，不计入占用房',
  indexDesc_free_room: '免费房',
  indexDesc_free_room_value: '“市场”为“免费”的登记单',
  indexDesc_free_room_value1: '对应的房间，不计入占用房',
  indexDesc_maintenance_room: '维修房',
  indexDesc_maintenance_room_value: '客房状态为“维修”的房间，',
  indexDesc_maintenance_room_value1: '维修房不计入占用房',
  indexDesc_locked_room: '锁定房',
  indexDesc_locked_room_value: '客房状态为“锁定”的房间，',
  indexDesc_locked_room_value1: '锁定房计入可售房',

  index_homeData_notarrRoom_value: '本日将到的房间总数',
  index_homeData_isarrRoom_value: '本日已到的房间总数',
  index_homeData_notdepRoom_value: '本日未离的房间总数',
  index_homeData_isdepRoom_value: '本日已离的房间总数',

  indexDesc_chart_desc: 'PS.饼图只是表示各类型占比，整圈度量不代表总房数',
  //version
  version_title: '版本信息',
  version_version: '版本号',
  version_tip1: '全新界面风格，采用类支付宝App首页的可定义功能按钮。',
  version_tip2: '增加消息模块，第一时间接收到有用的通知。',
  version_tip3: '增加餐饮、会议预订查询。',
  version_tip4: '增加事件预警、对酒店关键指标可预警提醒。',
  //cacheManger
  cacheManger_title: '缓存管理',
  cacheManger_clear: '清除',
  cacheManger_clearCloudAddress: '清除地址缓存',
  cacheManger_clearCloudParamCache: '清除参数缓存',
  cacheManger_clearCloudWithoutUserInfo: '清除除个人信息以外',
  cacheManger_clearAddress: '清除本机地址缓存',
  cacheManger_clearParamCache: '清除本机参数缓存',
  cacheManger_clearAllWithoutUserInfo: '清除本机除个人信息以外',
  //configeHotel
  configeHotel_title: '配置关注酒店',
  //couponUse
  couponUse_title: '卡券核销',
  couponUse_workstation: '营业点',
  couponUse_TodaySum: '本日累计',
  couponUse_Hotel: '全店',
  couponUse_Unit: '条',
  couponUse_Num: '券号',
  couponUse_sta: '状态',
  couponUse_P: '折',
  couponUse_Can_workstation: '适用营业点',
  couponUse_tip: '请先扫描优惠券',
  couponUse_need_workstation: '此优惠券需要指定营业点',
  couponUse_error_workstation: '当前营业点不能核销',

  couponUse_couponName: '名称',
  couponUse_couponCode: '代码',
  couponUse_couponTyDes: '类别',
  couponUse_cardNo: '会员卡',
  couponUse_couponType: '面值',
  couponUse_hotelDateSet: '适用日期',
  couponUse_validFromDate: '有效日期',
  couponUse_validToDate: '截止日期',
  couponUse_couponDes: '描述',
  couponUse_remark: '备注',
  couponUse_dis: '优惠券不可用',
  couponUse_getbarcode: '扫码',
  couponUse_btnv: '核销',
  couponUse_CouponUseSetting: '参数设置',
  couponUse_CouponUseHistory: '历史查询',

  couponUse_search_title: '核销历史',
  couponUse_search_user: '核销人',
  couponUse_search_date: '核销时间',
  couponUse_search_MemName: '姓名',

  //命名规则 路由+字段
  center_event_warning: '事件预警',
  center_feedback: '意见反馈',
  center_share_APP: '分享APP',
  center_cacheMange: '缓存管理',
  center_pushSend: '消息推送',
  center_version: '版本信息',
  center_licManage: '管理授权客户端',
  center_setting: '参数设置',
  center_message: '将离开本应用前往第三方调查平台，是否继续？',
  center_selfReportSetting: '自定义报表配置',
  center_thirdUrlSetting: '扩展程序配置',
  center_unBind: '解绑设备',
  center_unBind_confirm: '确定解绑设备吗?',

  center_clear_all_cache_title: '清除所有缓存',
  center_clear_all_cache: '确定清除所有缓存吗?',
  center_clear_all_cache_success: '缓存清除成功',

  //个人信息
  centerinfo_title: '个人信息',
  centerinfo_code: '用户名',
  centerinfo_mac: '设备ID',
  centerinfo_version: 'PMS版本',

  //事件预警
  eventWorm_title: '事件预警',
  eventWorm_descript: '事件名称',
  eventWorm_conditions: '条件',
  eventWorm_notice_content: '提醒内容',
  eventWorm_day_conditions: '天数条件',
  eventWorm_today: '当天',
  eventWorm_advance: '提前',
  eventWorm_day: '天',
  eventWorm_triggering_time: '触发时间',
  //版本号，版本信息 建议直接对应的if else写死
  //授权客户端
  licManage_title: '授权客户端',
  licManage_hotelCode: '酒店名称',
  licManage_limit: '限',
  licManage_client_number: '个客户端',
  licManage_all_records: '共有记录',
  licManage_records_unit: '条',
  licManage_prompt: '提示：左划删除记录',
  //授权客户端
  setting_title: '参数设置',
  setting_account_security: '账号与安全',
  setting_select_shift: '班别设置',
  setting_message_notice: '新消息通知',
  setting_clean_localStorage: '清除本地缓存',
  settinge_device: '设备信息',
  setting_mobileOrder_url: '设置手机点餐连接地址',
  setting_sys_option: '系统参数设置',

  // 系统参数设置
  setting_sys_option_desc: '描述',
  setting_sys_option_key: '字段名',
  setting_sys_option_value: '值',

  //账号和安全
  account_title: '账号与安全',
  account_lockerTip: '手势密码',
  account_lockerTip_sta_1: '已设置',
  account_lockerTip_sta_2: '未启用',
  account_lockerTip_label: '手势密码仅本机有效',
  account_tip: '如果遇到账号非正常登录，请及时修改密码，并联系管理员。',
  //accountLocker
  accountLocker_title: '手势密码',
  accountLocker_1: '启用手势密码',
  accountLocker_2: '修改手势密码',
  accountLocker_tip:
    '手势密码仅本机有效，禁用手势密码后登录密码将不保存，退出账号需要重新设置。',
  //anypay
  anypay_title: '任意付收银台',
  anypay_des: '结账金额',
  anypay_loading: '支付处理中...',
  anypay_action_search: '交易查询',
  anypay_action_goRefund: '交易退款',
  anypay_action_reAccount: '入账核对',
  anypay_scene: '扫码支付',
  anypay_overtime: '支付超时',
  anypay_backspace: '退格',
  anypay_alipay_wechat: '支付宝/微信',

  msg_goRefund: '你没有退款的权限',
  msg_payOrder: '支付金额不正确',
  msg_getbarcode: '非有效支付二维码',
  msg_paySuccess: '支付成功',
  msg_keyDown: '请输入支付金额',
  msg_than_price: '超过最多允许金额',
  msg_reAccount: '无上次订单号记录，无法核对入账，如有异常请人工处理',
  MessageBox_closeQ: '确定客人已经放弃本次支付?',
  //anyrefundList
  anyrefundList_title: '退款',
  anyrefundList_id: '订单ID',
  anyrefundList_feeName: '费用名称',
  anyrefundList_feeCode: '费用代码',
  anyrefundList_totalMoney: '总金额',
  anyrefundList_createDate: '支付时间',
  anyrefundList_taNo: '凭证号',
  anyrefundList_taWay: '付款方式',
  anyrefundList_feeName: '费用名称',
  anyrefundList_payMoney: '支付金额',
  anyrefundList_status: '状态',
  anyrefundList_detail: '详情',
  anyrefundList_alter: '撤销',
  anyrefundList_alter_success: '撤销成功',
  anyrefundList_nothing: '什么都没有',
  anyrefundList_nothingTxt: '请输入查询条件查询退款订单',
  anyrefundList_nothingTxt1: '(仅能退营业日当天订单）',
  anyrefundList_order_detail: '订单详情',
  anyrefundList_action_anpay: '收银台',
  anyrefundList_action_RefundList: '交易查询',
  anyrefundList_scene: '扫码退款',
  msg_refundOrder_sta: '退款状态为:',
  msg_checkOutRevoke: '账单撤销成功',
  msg_anyrefundList_search: '查询内容不能为空',
  MessageBox_showAlter: '是否确定撤销该订单?',
  //账号和安全
  anypaySearch_title: '交易查询',
  anypaySearch_orderNumer_placeholder: '凭证号 / 订单ID',

  //pushSend
  pushSend_title: '推送发送',
  pushSend_product: '目标系统',
  pushSend_product_placeholder: '目标系统(非空)',
  pushSend_hotelGroupCode: '集团代码',
  pushSend_hotelCode: '酒店代码',
  pushSend_loginName: '用户登录名',
  pushSend_push_title: '内容标题(非空)',
  pushSend_overview: '副标题',
  pushSend_content: '消息内容(非空)',
  pushSend_url: '链接地址',
  pushSend_save: '推送',
  msg_save1: '共推送',
  msg_save2: '条记录',
  MessageBox_pushSend_save: '确定推送?',
  //memberSearch
  memberSearch_title: '会员搜索',
  memberSearch_searchType_placeholder: '条件类型',
  memberSearch_seachContent_placeholder: '搜索条件',
  memberSearch_name: '姓名',
  memberSearch_cardNo: '卡号',
  memberSearch_mobile: '手机',
  memberSearch_address: '地址',
  memberSearch_dis: '请输入搜索条件',
  memberSearch_searchType_cardNo: '会员卡号',
  memberSearch_searchType_name: '会员姓名',
  memberSearch_searchType_mobile: '手机号码',
  memberSearch_searchType_idNo: '证件号码',
  memberSearch_searchType_email: '电子邮箱',
  msg_searchType: '请选择搜索条件类型',
  msg_searchOption: '请输入搜索条件',
  //memberDetail
  memberDetail_title: '会员详情',
  memberDetail_cardNo: '主卡号',
  memberDetail_sta: '状态',
  memberDetail_base_info: '基本信息',
  memberDetail_name: '姓名',
  memberDetail_sex: '性别',
  memberDetail_birth: '生日',
  memberDetail_isWechatMem: '是否微会员',
  memberDetail_accountBalance: '储值余额',
  memberDetail_pointBalance: '可用积分',
  memberDetail_accountTreatBalance: '赠送账号余额',
  memberDetail_idTypeDescript: '证件类型',
  memberDetail_idNo: '证件号码',
  memberDetail_companyName: '协议公司',
  memberDetail_loginTime: '登录时间',
  memberDetail_createDatetime: '注册时间',
  memberDetail_rateCode: '房价码',
  memberDetail_book: '预订客房',
  memberDetail_contact_info: '联系信息',
  memberDetail_mobile: '手机',
  memberDetail_email: '邮箱',
  memberDetail_phone: '电话',
  memberDetail_address: '地址',
  memberDetail_card_info: '会员卡信息',
  memberDetail_cardNo2: '卡号',
  memberDetail_cardTypeDescript: '会员计划',
  memberDetail_cardLevelDescript: '等级',
  memberDetail_staDescript: '状态',
  memberDetail_pointBalance: '积分余额',
  memberDetail_accountBalance: '储值余额',
  memberDetail_checkOutTime: '延迟退房时间',
  memberDetail_validity: '有效期',
  //memberDetail_createDatetime: "注册时间",
  //memberRegister
  memberRegister_title: '会员注册',
  memberRegister_cardType: '会员计划',
  memberRegister_cardLevel: '会员等级',
  memberRegister_taCode: '付款方式',
  memberRegister_taMoney: '付款金额',
  memberRegister_msg_no_taCode: '请选择付款方式',
  memberRegister_name: '姓名',
  memberRegister_name_placeholder: '请填写会员姓名（必填）',
  memberRegister_sex: '性别',
  memberRegister_sex_placeholder: '不可为空',
  memberRegister_mobile: '手机',
  memberRegister_mobile_placeholder: '请填写11位手机号码（必填）',
  memberRegister_password: '初始密码',
  memberRegister_password_placeholder: '（必填）',
  memberRegister_email_placeholder: '请填写Email地址（可空）',
  memberRegister_idType: '证件类型',
  memberRegister_idNo: '证件号码',
  memberRegister_idNo_placeholder: '请填写证件号码(可空)',
  memberRegister_cardSrc: '来源',
  memberRegister_cardSrc_placeholder: '可空',
  memberRegister_salesman: '销售员',
  memberRegister_salesman_placeholder: '可空',
  memberRegister_confirm: '注册',
  msg_sfzRe: '识别失败！请正面对准身份证，当照片清楚时再拍摄。',
  msg_isEmpty_name: '姓名不能为空',
  msg_isEmpty_mobile: '手机不能为空',
  msg_isEmpty_password: '密码不能为空',
  msg_book: '注册成功',
  MessageBox_confirmB: '确定注册?',
  //AccountIn
  AccountIn_title: '入账',
  AccountIn_rmno: '房间号',
  AccountIn_name: '姓名',
  AccountIn_taCode: '代码',
  AccountIn_clubCard: '会员卡',
  AccountIn_money: '费用',
  AccountIn_money_placeholder: '请填写本次入账费用（必填）',
  AccountIn_taNo: '单号',
  AccountIn_taRemark: '备注',
  AccountIn_save: '入账',
  msg_isEmpty_taCode: '请选择费用代码',
  msg_isEmpty_cardNo: '请选择会员卡',
  msg_isEmpty_money: '请填写费用金额',
  msg_isEmpty_money2: '请填写正确金额',
  MessageBox_AccountIn_save: '确定入账金额：',
  MessageBox_AccountIn_remove_item: '确定要删除该项吗?',

  JJ_AccountIn_title: '账务调整',
  JJ_AccountIn_reason: '理由',
  msg_need_reason: '请选择理由',

  //selfReportSetting
  selfReportSetting_title: '自定报表设置',
  selfReportSetting_name: '报表名称',
  selfReportSetting_name_placeholder: '建议2-6个字',
  selfReportSetting_code: '报表代码',
  selfReportSetting_code_placeholder: '请填写过程名称（必填）',
  selfReportSetting_procName: '过程名称',
  selfReportSetting_procName_placeholder: '过程名称（必填）',
  selfReportSetting_type: '模板类型',
  selfReportSetting_type_tip2: '单日期酒店:过程为3参数<br>范围日期酒店：过程为4参数',
  selfReportSetting_icon: '图标',
  selfReportSetting_icon_placeholder: '选择功能图标',
  selfReportSetting_color: '颜色',
  selfReportSetting_color_placeholder: '选择图标颜色',
  selfReportSetting_data_src: ' 数据来源',
  selfReportSetting_data_src_placeholder: ' 不可为空',
  selfReportSetting_createDate: ' 创建时间',
  selfReportSetting_deleteEv: ' 删除成功',
  //selfReportEdit
  selfReportEdit_title: '定义报表',
  selfReportEdit_column: '字段列名',
  selfReportEdit_column_c: '字段名',
  selfReportEdit_column_n: '显示中文',
  selfReportEdit_column_w: '宽度%',
  selfReportEdit_column_addC: '添加',
  selfReportEdit_column_number: '序号',
  selfReportEdit_column_field: '字段名',
  selfReportEdit_column_chinese: '显示中文',
  selfReportEdit_column_i: '缩进条件:列名,值 (可空)',
  selfReportEdit_column_i_tip: '例：type:1  表示本行记录type例的值为1时显示时会缩进显示，其它条件不缩进',
  selfReportEdit_column_a: '对齐',
  selfReportEdit_column_a_tip: '可选：left,right,center',
  selfReportEdit_column_action: '操作',
  selfReportEdit_column_Index: '缩进',
  selfReportEdit_column_JSON: '以json方式查看',
  selfReportEdit_column_b: '着重',
  selfReportEdit_users: '权限键值',
  selfReportEdit_users_placeholder: '填写PMS权限控制的键值',
  selfReportEdit_disOption: '显示选项',
  selfReportEdit_ext2: '显示扩展2',
  selfReportEdit_ext3: '显示扩展3',
  selfReportEdit_listOrder: '排序值',
  selfReportEdit_listOrder_placeholder: '排序值(可空)',
  selfReportEdit_ext_placeholder: '可空',
  selfReportEdit_ishalt: '是否停用',
  selfReportEdit_ishalt_placeholder: '不可为空',
  selfReportEdit_remark: '备注',
  selfReportEdit_dataType_dateTable: '单日期酒店选择表格',
  selfReportEdit_dataType_rangTable: '范围日期酒店选择报表',
  selfReportEdit_First_line_sum: '首行为合计',
  selfReportEdit_Auto_scroll: '滚动时自动锁定标题',

  selfReportEdit_dataType_group: '集团端',
  selfReportEdit_dataType_pms: '门店库（暂不支持）',
  selfReportEdit_dataType_member: '会员库（暂不支持）',

  selfReportEdit_TF_F: '启用',
  selfReportEdit_TF_T: '停用',

  // thirdUrlSetting
  thirdUrlSetting_title: '扩展程序配置',
  thirdUrlSetting_createDate: ' 创建时间',

  // thirdUrlEdit
  thirdUrlSetting_code: '扩展代码',
  thirdUrlSetting_code_placeholder: '请填写扩展代码',
  thirdUrlSetting_name: '扩展名称',
  thirdUrlSetting_name_placeholder: '请填写扩展名称',
  thirdUrlSetting_url: '扩展地址',
  thirdUrlSetting_url_placeholder: '请填写扩展地址',
  thirdUrl_msg_isEmpty_code: '扩展代码不能为空',
  thirdUrl_msg_isEmpty_name: '扩展名称不能为空',
  thirdUrl_msg_isEmpty_url: '扩展地址不能为空',

  msg_isEmpty_addColumn_c: '列名不能为空',
  msg_isEmpty_addColumn_n: '显示中文不能为空',
  msg_isEmpty_addColumn_w: '宽度不能为空',
  msg_isEmpty_code: '代码不能为空',
  msg_isEmpty_name: '名称不能为空',
  msg_isEmpty_procName: '过程不能为空',
  msg_isEmpty_right: '权限键值不能为空',
  msg_isEmpty_columns: '字段列名不能为空',
  msg_only_group: '当前仅支持集团端取数据',
  //couponUseSetting
  couponUseSetting_title: '核销设置',
  couponUseSetting_operating_point: '营业点',
  //账号和安
  messagePush_title: '新消息设置',
  messagePush_receiveAlert: '接收预警消息',
  messagePush_receiveSystem: '接收系统消息',
  messagePush_startApp: '收到消息启动APP',
  messagePush_vibration: '开启震动',
  messagePush_voice: '语音',
  messagePush_tipBox: '当App运行时，你可以设置是否需要声音或震动。',

  //账号和安全
  device_title: '设备信息',
  device_name: '系统名称',
  device_language: '系统语言',
  device_version: '系统版本',
  device_vendor: '系统供应商',
  device_model: '设备型号',
  device_vendor2: '生产厂商',
  device_mac: '设备ID',
  device_network: '网络类型',
  device_screen: '分辨率',
  device_scale: '显示比例',
  device_scale: '显示比例',
  device_uuid: '设备ID',
  device_message: '清除后将重新登录，是否清除?',

  //账务代码
  accountCode_Title: '营业项目',
  accountCode_SearchPlaceHold: '根据代码或名称搜索',
  accountCode_common: '常用',
  accountCode_fee: '消费',
  accountCode_pay: '付款',
  accountCode_preAuth: '预授权',
  accountCode_list: '列表',

  //日期酒店搜索
  dateHotel_SearchHotel: '请选择酒店名称',

  //日期控件
  controll_datepicker_to: '至',
  controll_datepicker_clear: '清除',
  controll_datepicker_selectEndDate: '请选择结束时间',

  controll_datepik_no_next: '不能向后了',
  controll_datepik_no_pre: '不能向前了',

  //弹框搜索会员协议公司
  pop_search_isGroup: '是否集团搜索',
  pop_search_cardNo: '会员卡号',
  pop_search_mobile: '手机',
  pop_search_idNo: '证件',
  pop_search_cardType: '卡类',
  pop_search_rateCode: '房价码',
  pop_search_No: '编号',
  pop_search_src: '来源码',
  pop_search_market: '市场码',
  pop_search_cms: '佣金码',
  pop_search_saleman: '销售员',
  pop_search_searchTile: '请输入搜索条件',
  pop_search_mem_placeHolder: '搜索会员卡',
  pop_search_mem_SearchplaceHolder: '输入会员卡号/手机号搜索',
  pop_search_A_placeHolder: '搜索旅行社',
  pop_search_A_SearchplaceHolder: '输入旅行社名字搜索',
  pop_search_C_placeHolder: '搜索协议公司',
  pop_search_C_SearchplaceHolder: '输入协议公司名字搜索',
  pop_search_S_placeHolder: '搜索订房中心',
  pop_search_S_SearchplaceHolder: '输入订房中心名字搜索',

  //酒店搜索
  contrll_search_range: '选择范围',
  //控件topDatePick
  contrll_topDatePick_no_less_today: '不能查小于今天的',
  contrll_no_big_yesterday: '不能查大于昨天的',
  Update_LOG: '更新日志',
  contrll_at_least: '请至少选择一家酒店',
  contrll_self_choice: '自选 ',
  contrll_num_hotel: ' 家酒店',
  contrll_only_hotel: '请选择酒店',


  // discover 发现
  discover_title: '发现',
  discover_ad_icon: '广告',

  // loginRecord 登录记录
  loginRecord_title: '登录记录',
  loginRecord_title_self: '本人的登录记录',
  loginRecord_title_all: '所有的登录记录',
  loginRecord_ip: '登录IP',
  loginRecord_time: '登录时间',

  // 快速预定会议
  meetingBookFast_page_title: '快捷会议预定',
  meetingBookFast_title: '请选择会议室',
  meetingBookFast_select_time: '请选择时间',
  meetingBookFast_time: '会议日期',
  meetingBookFast_time_part: '时间段',
  meetingBookFast_msg_selecte_part: '至少选择一个时间段',

  // reportViewRange 酒店营收报表范围
  reportViewRange_title: '酒店营收报表范围',
  reportViewRange_project: '项目',
  reportViewRange_current_period: '本期',
  reportViewRange_corresponding_period: '同期',


  // memberContrast 会员对比
  memberContrast_title: '会员对比',
  memberContrast_current: '当期',
  memberContrast_lastyear: '去年同期',
  memberContrast_compare: '同比',

  // memberMoreHotelContrast 会员状况
  memberMoreHotelContrast_title: '会员状况',
  memberMoreHotelContrast_mem_title: '会员卡',
  memberMoreHotelContrast_register_time: '注册数',
  memberMoreHotelContrast_consume_time: '消费次数',
  memberMoreHotelContrast_consume_money: '消费金额',
  memberMoreHotelContrast_charge_money: '充值金额',

  // memberSingleContrast 会员指标
  memberSingleContrast_title: '会员指标',
  memberSingleContrast_quota: '指标',

  // memberPerformance 会员总体
  memberPerformance_title: '会员总体',
  memberPerformance_order: '排序',
  memberPerformance_roomIncome: '客房收入',
  memberPerformance_roomProportion: '客房收入占比',
  memberPerformance_roomCompared: '客房收入同比',

  memberPerformance_foodIncome: '餐饮收入',
  memberPerformance_foodProportion: '餐饮收入占比',
  memberPerformance_foodCompared: '餐饮收入同比',

  memberPerformance_otherIncome: '其他收入',
  memberPerformance_otherProportion: '其他收入占比',
  memberPerformance_otherCompared: '其他收入同比',


  // opera orderDetail
  operaOrderDetail_sure_checkout: '确定退房?',
  operaOrderDetail_sure_money: '金额必需大于0',
  operaOrderDetail_sure_account_in: '确定入账?',
  operaOrderDetail_sure_not_end: '入住日期未到',
  operaOrderDetail_sure_checkIn: '确定入住?',
  operaOrderDetail_sure_cancel_reason: '请输入取消订单原因（可空）',
  operaOrderDetail_room: '房间',
  operaOrderDetail_room_choose: '已选择',
  operaOrderDetail_room_over: '超过本次允许的房间数',
  operaOrderDetail_room_no: '请先选择房间！',
  operaOrderDetail_room_special: '请先选择具体的房间',
  operaOrderDetail_room_confirm1: '是否对房间',
  operaOrderDetail_room_confirm2: '进行排房',


  // searchHotel
  searchHotel_opera_notice: 'opera酒店不能加入多选',
  searchHotel_opera_notice2: '不能选择opera酒店',

  // operaOrder
  operaOrder_title: '房间步入',
  operaOrder_live_in_date: '入住日期',
  operaOrder_room: '房',
  operaOrder_bookinfo_name: '请填写预订人姓名（必填)',
  operaOrder_bookinfo_mobile: '请填写预订人手机（必填)',
  operaOrder_bookinfo_id: '身份证号',
  opera_search_history: '历史搜索',

  // operaBook
  operaBook_checkin_time: '入住时间',
  operaBook_leave_time: '离店时间',
  operaBook_search_rmno: '搜索房价码', // Rate Code


  // 锦江相关
  jj_door_card_info: '门卡信息',
  jj_room_no: '房号',
  jj_beginTime: '开始时间',
  jj_endTime: '结束时间',
  jj_doorCard_operate: '门卡操作',
  jj_addCard: '发新卡',
  jj_addCard_success: '门卡新增成功',
  jj_copyCard: '复制卡',
  jj_copyCard_success: '门卡复制成功',
  jj_readCard: '读卡',
  jj_readCard_success: '门卡读取成功',
  jj_cancelCard: '注销卡',
  jj_cancelCard_success: '门卡注销成功',
  jj_setting: '账号配置',
  jj_token_error: '获取锦江token失败，请先配置锦江信息',
  jj_empty_card: '此卡为空卡',
  jj_cancel_text: '注销',
  jj_id_card_read_success: '身份证读取成功',
};



// WEBPACK FOOTER //
// ./src/locale/lang/zh_CN.js